import { RootState } from "@/lib/state/store";

export const animationPaletteSelector = (state: RootState) => {
  return state.animation.palette;
};
